import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function createOrUpdateBonificationByModelId(body) {
    const response = await axios.put(
        `${REACT_APP_API}/bonifications/conventional/model`,
        body
    )

    return response?.data?.data
}
